/**
 * 动态定制界面
 */

import Vue from "vue";
import { MethodService } from "@/utils/serviceModel";

import GhClassService from "./mixins/clsService";

const getCodeMethod: MethodService = new MethodService(
  "mes.business.sys.page",
  "PageCodeService",
  "get_page_code"
);

export default function parseCode(id, start?: () => void, finish?: () => void) {
  let promise = (resolve, reject) => {
    if (start) {
      start();
    }
    getCodeMethod
      .invokeAsyn({ id })
      .then(res => {
        if (res.data.isSuccess) {
          let com: IndexObject = {};
          let code = res.data.data;
          try {
            com = eval(code);
            // com.mixins = [GhClassService];
            // let vue = new Vue(com);

            resolve(com);
          } catch (error) {
            console.log(error);
          }
        } else {
          reject(res.data.error);
        }
      })
      .catch(res => {
        reject();
      })
      .finally(() => {
        if (finish) {
          finish();
        }
      });
  };
  return promise;
}
